// export const loginUser = (state, { user, token }) => {
//     if (token) {
//         localStorage.setItem('token', token)
//         state.idToken = token
//     }

//     state.user = user
//     state.status = 'authenticated'
// }
import { plainAxiosInstanceAuth } from '../../api/apiMeta'

export const setUserInfo = (state, data) => {
    localStorage.setItem("auth_token", data.headers.authorization);
    plainAxiosInstanceAuth.defaults.headers.common["Authorization"] = data.headers.authorization;
    state.user = {
        id: data.data.user.id,
        name: `${data.data.user.name} ${data.data.user.last_name}`,
        email: data.data.user.email,
        rol: data.data.user.rol
    };
    state.auth_token = data.headers.authorization;
    state.status = 'authenticated';
}

export const setUserInfoFromToken = (state, data) => {
    state.user = {
        id: data.data.user.id,
        name: `${data.data.user.name} ${data.data.user.last_name}`,
        email: data.data.user.email,
        rol: data.data.user.rol
    };
    state.auth_token = localStorage.getItem("auth_token");
    state.status = 'authenticated';
}

export const resetUserInfo = (state) => {
    state.user = {
        id: null,
        name: null,
        email: null,
        rol: null
    };
    state.auth_token = null;
    state.status = 'not-authenticated';
    localStorage.removeItem("auth_token");
    plainAxiosInstanceAuth.defaults.headers.common["Authorization"] = null;
}